// extracted by mini-css-extract-plugin
module.exports = {"palette__grid":"PaletteGrid_palette__grid__1ppCM","grid__item":"PaletteGrid_grid__item__2END1"};